<template>
	<div class="container">
		<div class="m_sub_top">
			<div class="top_content">
				<h2 class="headline_m">
					{{ $t('rtr_personal-request-send.title1') }}<br />
					{{ $t('rtr_personal-request-send.title2') }}
				</h2>
				<p class="body_m">
					{{ $t('rtr_personal-request-send.text1') }}<br />{{
						$t('rtr_personal-request-send.text2')
					}}
				</p>
				<div class="button_area">
					<button class="button_bg_red mr_10" @click="toLogin">
						{{ $t('button.asset_send') }}
					</button>
					<button class="button_bg_black" @click="notYet">
						{{ $t('button.down') }}
					</button>
				</div>
			</div>
		</div>
		<section>
			<div class="content_area type_2 bg_gray1">
				<p class="title_m">
					{{ $t('rtr_personal-request-send.text3') }}
				</p>
				<div>
					<swiper :centered-slides="true" :slides-per-view="1.5">
						<swiper-slide>
							<div class="rectangle_w">
								<div>
									<div>
										<img
											src="@/assets/images/sub/send_icon_01.png"
											alt=""
											class="mb_20"
										/>
									</div>
									<p class="title_s">
										{{ $t('rtr_personal-request-send.text4') }}
									</p>
									<p class="body_m">
										{{ $t('rtr_personal-request-send.text5') }}<br />
										{{ $t('rtr_personal-request-send.text6') }}<br />{{
											$t('rtr_personal-request-send.text7')
										}}
									</p>
								</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<div class="rectangle_w">
								<div>
									<div>
										<img
											src="@/assets/images/sub/send_icon_02.png"
											alt=""
											class="mb_20"
										/>
									</div>
									<p class="title_s">
										{{ $t('rtr_personal-request-send.text8') }}
									</p>
									<p class="body_m">
										{{ $t('rtr_personal-request-send.text9') }}
										{{ $t('rtr_personal-request-send.text10') }}
										{{ $t('rtr_personal-request-send.text11') }}
									</p>
								</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<div class="rectangle_w">
								<div>
									<div>
										<img
											src="@/assets/images/sub/send_icon_03.png"
											alt=""
											class="mb_20"
										/>
									</div>
									<p class="title_s">
										{{ $t('rtr_personal-request-send.text12') }}
									</p>
									<p class="body_m">
										{{ $t('rtr_personal-request-send.text13') }}<br />
										{{ $t('rtr_personal-request-send.text14') }}<br />
										{{ $t('rtr_personal-request-send.text15') }}
									</p>
								</div>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</section>

		<section>
			<div class="content_area">
				<div class="detail_area">
					<div class="detail">
						<h2 class="headline_s">
							{{ $t('rtr_personal-request-send.title4') }}
						</h2>
						<div class="img_area_02">
							<img src="@/assets/images/sub/send_02.png" alt="" />
						</div>
						<div class="text">
							<p class="body_m">
								{{ $t('rtr_personal-request-send.text16') }}<br />
								{{ $t('rtr_personal-request-send.text17') }}
							</p>
						</div>
					</div>
				</div>
				<div class="detail_area">
					<div class="detail">
						<h2 class="headline_s">
							{{ $t('rtr_personal-request-send.title5') }}
						</h2>
						<div class="img_area_02">
							<img src="@/assets/images/sub/send_03.png" alt="" />
						</div>
						<p class="body_m">
							{{ $t('rtr_personal-request-send.text18') }}<br />{{
								$t('rtr_personal-request-send.text19')
							}}<br /><br />
							{{ $t('rtr_personal-request-send.text20') }}<br />
						</p>
					</div>
				</div>
			</div>
		</section>
		<section
			class="content_area background d_flex justify_center align_items_center"
		>
			<div>
				<h2 class="headline_s fc_white mb_20">
					{{ $t('rtr_personal-request-send.text21') }}<br />{{
						$t('rtr_personal-request-send.text22')
					}}
				</h2>
				<p class="body_m fc_gray">
					{{ $t('rtr_personal-request-send.text23') }}
					{{ $t('rtr_personal-request-send.text24') }}
				</p>
			</div>
		</section>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';
import { Pagination, Navigation } from 'swiper';
export default {
	name: 'Send.m',
	setup() {
		return {
			modules: [Pagination, Navigation],
		};
	},
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
<style scoped></style>
